/** Native horizontal scrolling also works before JavaScript and with touch/trackpads. */
export const enhanceCrossSellRail = (section) => {
    const rail = section.querySelector('[data-cross-sell-rail]');
    const controls = section.querySelector('[data-cross-sell-controls]');
    if (!rail || !controls) return;
    const win = section.ownerDocument.defaultView;
    const previous = controls.querySelector('[data-cross-sell-step="-1"]');
    const next = controls.querySelector('[data-cross-sell-step="1"]');
    const position = controls.querySelector('[data-cross-sell-position]');
    const step = () => rail.children.length > 1 ? rail.children[1].offsetLeft - rail.children[0].offsetLeft : rail.clientWidth;
    const update = () => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        controls.hidden = maximum < 2;
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft >= maximum - 2;
        const first = Math.min(rail.children.length, Math.round(rail.scrollLeft / (step() || 1)) + 1);
        const last = Math.min(rail.children.length, Math.max(first, Math.floor((rail.scrollLeft + rail.clientWidth - (rail.children[0]?.offsetWidth || 0) + 2) / (step() || 1)) + 1));
        const visible = position.hasAttribute('data-cross-sell-range') && last > first ? `${first}–${last}` : first;
        position.textContent = `${visible} / ${rail.children.length}`;
    };
    const onStep = (event) => {
        const button = event.target.closest('[data-cross-sell-step]');
        if (!button || button.disabled) return;
        rail.scrollBy({ left: Number(button.dataset.crossSellStep) * step(), behavior: win.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    };
    controls.addEventListener('click', onStep);
    rail.addEventListener('scroll', update, { passive: true });
    const observer = win.ResizeObserver ? new win.ResizeObserver(update) : null;
    if (observer) observer.observe(rail);
    else win.addEventListener('resize', update);
    update();
    return () => {
        controls.removeEventListener('click', onStep);
        rail.removeEventListener('scroll', update);
        if (observer) observer.disconnect();
        else win.removeEventListener('resize', update);
    };
};
